import React from 'react';

import i18next from 'i18next';

const Banner = ({ subBanners, imageLink1, imageNumber }) => {
  let bannerImageEn = [];
  let bannerImageEs = [];

  if (subBanners) {
    subBanners &&
      subBanners.en.forEach(item => {
        bannerImageEn.push(item);
      });
    subBanners &&
      subBanners.es.forEach(item => {
        bannerImageEs.push(item);
      });
  }

  const banners = bannerImageEn.length && i18next.language == 'es' ? bannerImageEs : bannerImageEn;

  return (
    <React.Fragment>
      {banners.map((item, i) => (
        <div className="home-banner pullman-section-primary-row-container">
          <div className="themes-home-section-1-images">
            {i === imageNumber ? (
              <div
                onClick={imageLink1}
                style={{
                  position: 'absolute',
                  width: '244px',
                  height: '165px',
                  cursor: 'pointer',
                }}
              />
            ) : null}
            <div style={{ maxWidth: '90%' }}>
              <img src={item} alt="banner" />
            </div>
          </div>
        </div>
      ))}
      {/* <div className="home-banner pullman-section-primary-row-container">
        <div className="themes-home-section-1-images">
          <div style={{ maxWidth: '90%' }}>
            <img
              src={
                bannerImageEn.length && i18next.language == 'es'
                  ? bannerImageEs[0]
                  : bannerImageEn[0]
              }
              alt="banner"
            />
          </div>
        </div>
      </div> */}
      {/* <div className="home-banner pullman-section-primary-row-container">
        <div className="themes-home-section-1-images">
          {link ? (
            <div
              onClick={link}
              style={{
                position: 'absolute',
                width: '244px',
                height: '165px',
                cursor: 'pointer',
              }}
            />
          ) : null}
          <div style={{ maxWidth: '90%' }}>
            <img
              src={
                bannerImageEn.length && i18next.language == 'es'
                  ? bannerImageEs[1]
                  : bannerImageEn[1]
              }
              alt="banner"
            />
          </div>
        </div>
      </div> */}
    </React.Fragment>
  );
};

export default Banner;



// WEBPACK FOOTER //
// ./src/features/home/Banner/SubBanner.js